import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const lenis = window.lenisInstance;
  const blocks = document.querySelectorAll(".animated-hero");

  blocks.forEach((block) => {
    const mask = block.querySelector("[data-animated-hero-mask]");
    const pin = block.querySelector("[data-animated-hero-pin]");
    const trail = block.querySelector(".animated-hero-asset");
    const slides = Array.from(trail.children);
    const firstSlide = slides[0];
    const autoplay = block.dataset.autoplay === "true";

    const isFullscreenIntro = block.dataset.fullscreenIntro === "true";
    const shouldStopScrollAndHideHeader = isFullscreenIntro && window.scrollY <= 100;

    const videoControls = block.querySelector("[data-video-controls]");
    const scrollBadge = block.querySelector("[data-scroll-badge]");

    if (!mask || !pin || slides.length === 0) return;

    if (shouldStopScrollAndHideHeader) {
      window.hideHeader && window.hideHeader();
    }

    gsap.set(slides, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100dvh",
      opacity: 0,
    });

    // gsap.set(mask, { scale: 1.5 });
    gsap.set(firstSlide, { opacity: 1, zIndex: 1 });
    const hiddenUi = [videoControls, scrollBadge].filter(Boolean);
    if (hiddenUi.length > 0) {
      gsap.set(hiddenUi, { opacity: 0 });
    }

    const scrollTriggerOptions = {};
    if (isFullscreenIntro) {
    } else {
      scrollTriggerOptions.pin = pin;
      if (autoplay) {
        scrollTriggerOptions.toggleActions = "play none none none";
        scrollTriggerOptions.scrub = false;
      } else {
        scrollTriggerOptions.scrub = 1;
      }
    }

    const mainTl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: "top top",
        end: "bottom top",
        ...scrollTriggerOptions,
      },
      onComplete: () => {
        if (isFullscreenIntro && window.showHeader) {
          window.showHeader();
          // lenis?.start();
        }
      },
    });

    const tl1 = gsap.timeline();

    tl1.to(mask, {
      scale: 100,
      x: "150%",
      transformOrigin: "center",
      ease: "expo.in",
      duration: 1.5,
    });

    tl1.to(mask, { opacity: 0, zIndex: -1 });

    tl1.addLabel("Finish");

    const tl2 = gsap.timeline();

    slides.forEach((slide, index) => {
      const isFirst = index === 0;
      const isLast = index === slides.length - 1;
      const length = slides.length;

      const overlay = slide.querySelector(".wp-block-cover__background");
      const asset = slide.querySelector(".wp-block-cover__image-background");
      const innerContainer = slide.querySelector(
        ".wp-block-cover__inner-container"
      );

      tl2.addLabel("Start");

      if (!isFirst || length === 1) {
        tl2.to(
          slide,
          { opacity: 1, duration: 1, ease: "power2.inOut" },
          `slide-${index}`
        );
      }

      if (asset) {
        tl2.fromTo(
          asset,
          { scale: 1.15, ...(!isFirst && { filter: "blur(8px)" }) },
          { scale: 1, filter: "blur(0px)", duration: 1.2, ease: "expo.out" },
          `slide-${index}`
        );
      }

      if (overlay) {
        tl2.from(overlay, { opacity: 0 }, `slide-${index}`);
      }

      if (innerContainer && !isLast) {
        tl2.from(
          innerContainer,
          { opacity: 0, y: 50, ease: "expo.out", duration: 0.5 },
          `slide-${index}+=0.5`
        );
      }
    });

    // Animate scrollBadge, videoControls and last innerContainer together
    const lastSlideIndex = slides.length - 1;
    const lastSlide = slides[lastSlideIndex];
    const lastInner = lastSlide?.querySelector(".wp-block-cover__inner-container");
    const uiElements = [lastInner, scrollBadge, videoControls].filter(Boolean);

    if (uiElements.length > 0) {
      // lastInner uses .from (starts hidden by CSS), scrollBadge/videoControls use .to (set to opacity:0 by gsap)
      if (lastInner) {
        tl2.from(
          lastInner,
          { opacity: 0, y: 20, ease: "power2.out", duration: 1 },
          `slide-${lastSlideIndex}+=0.2`
        );
      }
      const fadeinUi = [scrollBadge, videoControls].filter(Boolean);
      if (fadeinUi.length > 0) {
        tl2.to(
          fadeinUi,
          { opacity: 1, y: 0, ease: "power2.out", duration: 1 },
          `slide-${lastSlideIndex}+=0.2`
        );
      }
    }

    if (isFullscreenIntro) {
      const videos = block.querySelectorAll("video");

      if (videos.length > 0) {
        const volumeBtn = videoControls?.querySelector("[data-video-volume]");
        const playBtn = videoControls?.querySelector("[data-video-playback]");

        playBtn?.addEventListener("click", () => {
          videos.forEach((video) => {
            playBtn.classList.toggle("active");
            video.paused ? video.play() : video.pause();
          });
        });
        volumeBtn?.addEventListener("click", () => {
          videos.forEach((video) => {
            volumeBtn.classList.toggle("active");
            video.muted = !video.muted;
            video.volume = video.muted ? 0 : 1;
          });
        });
      }
    }

    mainTl.add(tl1);
    mainTl.add(tl2);
  });
});
